/**
 * 獲得状況の絞り込み
 *
 * ラリー地図とラリー詳細で同じ条件を使うので、型と判定はここに寄せる。
 */

export type StampFilter = 'all' | 'stamped' | 'unstamped'

export const STAMP_FILTER_LABELS: Record<StampFilter, string> = {
  all: 'すべて',
  stamped: '獲得済み',
  unstamped: '未獲得',
}

export const isStampFilter = (value: string): value is StampFilter => value in STAMP_FILTER_LABELS

export const matchesStampFilter = (stampedAt: string | null, filter: StampFilter): boolean => {
  if (filter === 'stamped') return stampedAt !== null
  if (filter === 'unstamped') return stampedAt === null
  return true
}
